import * as models from 'smg/customer-api/models';
import * as template from 'smg/template';

import { State } from '../../state';

import { BindBackLink, PromoteFormBodyIDs } from './shared';

// RenderPayPalForm shows the PayPal branding/disclaimer; the actual
// redirect to PayPal happens later in submit.ts via paypal.CreateOrder.
export function RenderPayPalForm(state: State, $el: HTMLElement, back: () => void): void {
    $el.replaceChildren(template.Clone('#payment-option-form-paypal'));
    PromoteFormBodyIDs($el);
    state.initPaymentTypeSelect(state.payment.paymentOptionTypeID ?? models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PAY_PAL, $el);
    BindBackLink($el, back);
}
